export { default } from "./src/sliding-layout";

export type { UniformSlidingLayoutProps } from "./src/sliding-layout";
